var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"tw-flex tw-justify-between tw-text-[#b3b9c6]"},[_c('span',{staticClass:"tw-font-georgia"},[_vm._v("\n    "+_vm._s(_vm.analysisDate)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"tw-font-poppins"},[_vm._v("\n    Investment Proposal\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }